import {
	ClientPortfolioDataChangeChangeTypeEnum,
	type ClientPortfolioLoanChangeRequestDTO,
} from "web_myplann/Infrastructure/Api/Api";

export const withOwnLoanChange = <
	T extends { change?: ClientPortfolioLoanChangeRequestDTO | null },
>(
	portfolioFields: T,
	change: ClientPortfolioLoanChangeRequestDTO,
): T => {
	if (!portfolioFields.change) {
		return portfolioFields;
	}

	return {
		...portfolioFields,
		change: {
			...change,
			changeType: ClientPortfolioDataChangeChangeTypeEnum.OWN_CHANGE,
		},
	};
};
